export const TEST_IDS = {
  startDeal: {
    lead: {
      assignDealer: 'start-deal-lead-assign-dealer',
      dealerLocation: 'start-deal-lead-dealer-location',
      selectedContact: 'start-deal-lead-selected-contact',
      businessName: 'lead-business-name',
      contact: 'lead-contact',
      title: 'lead-title',
      email: 'lead-email',
      phone: 'lead-phone',
    },
    equipment: {
      quantity: 'equipment-quantity',
      year: 'equipment-year',
      make: 'equipment-make',
      model: 'equipment-model',
      class: 'equipment-class',
      serialNumberVin: 'equipment-serial-number-vin',
      stockId: 'equipment-stock-id',
      condition: 'equipment-condition',
      mileage: 'equipment-mileage',
      description: 'equipment-description',
      wholesaleCost: 'equipment-wholesale-cost',
      retailPrice: 'equipment-retail-price',
      actions: {
        searchInventory: 'equipment-search-inventory-btn',
        uploadImages: 'equipment-upload-images-btn',
        previewImages: 'equipment-preview-images-btn',
      },
    },
    saleDetails: {
      saleType: 'sale-details-sale-type',
      equipmentSubtotal: 'sale-details-equipment-subtotal',
      salesTax: 'sale-details-sales-tax',
      fees: 'sale-details-fees',
      netTrade: 'sale-details-net-trade',
      invoiceTotal: 'sale-details-invoice-total',
      downPaymentFlat: 'sale-details-down-payment-flat',
      financeAmount: 'sale-details-finance-amount',
    },
  },
  desking: {
    contact: {
      selectContact: 'desking-contact-select-contact',
      customerName: 'desking-contact-customer-name',
      email: 'desking-contact-email',
      phone: 'desking-contact-phone',
    },
    equipment: {
      selectEquipment: 'desking-equipment-select-equipment',
      quantity: 'desking-equipment-quantity',
      year: 'desking-equipment-year',
      make: 'desking-equipment-make',
      model: 'desking-equipment-model',
      class: 'desking-equipment-class',
      serialNumberVin: 'desking-equipment-serial-number-vin',
      stockId: 'desking-equipment-stock-id',
      condition: 'desking-equipment-condition',
      mileage: 'desking-equipment-mileage',
      description: 'desking-equipment-description',
      wholesaleCost: 'desking-equipment-wholesale-cost',
      retailPrice: 'desking-equipment-retail-price',
      actions: {
        searchInventory: 'desking-equipment-search-inventory-btn',
        addEquipment: 'desking-equipment-add-equipment-btn',
        saveEquipment: 'desking-equipment-save-equipment-btn',
        updateEquipment: 'desking-equipment-update-equipment-btn',
        uploadImages: 'desking-equipment-upload-images-btn',
        previewImages: 'desking-equipment-preview-images-btn',
      },
    },
    finance: {
      selectProgram: 'desking-finance-select-program',
      rateType: 'desking-finance-rate-type',
      specifyRatePerTerm: 'desking-finance-specify-rate-per-term',
      terms: 'desking-finance-terms',
      commonRate: 'desking-finance-common-rate',
      programType: 'desking-finance-program-type',
      minimumDownPayment: 'desking-finance-minimum-down-payment',
      residual: 'desking-finance-residual',
      advancePayment: 'desking-finance-advance-payment',
      startDate: 'desking-finance-start-date',
      firstPaymentDate: 'desking-finance-first-payment-date',
      daysToFirstPayment: 'desking-finance-days-to-first-payment',
      programName: 'desking-finance-program-name',
    },
    sendVia: {
      type: 'desking-send-via-type',
      ccEmail: 'desking-send-via-cc-email',
    },
    notesToBuyer: {
      notes: 'desking-notes-to-buyer',
    },
    structure: {
      resetBtn: 'desking-structure-reset-btn',
      financeBtn: 'desking-structure-finance-btn',
      menuBtn: 'desking-structure-menu-btn',
    },
    panelActions: {
      send: 'desking-panel-actions-send-btn',
      saveAsDraft: 'desking-panel-actions-save-as-draft-btn',
    },
  },
  inventory: {
    searchDialog: {
      dialog: 'inventory-search-dialog',
      actions: {
        cancel: 'inventory-search-dialog-cancel-btn',
        add: 'inventory-search-dialog-add-btn',
      },
    },
  },
  proposals: {
    createProductDialog: {
      dialog: 'proposals-create-product-dialog',
      actions: {
        cancel: 'proposals-create-product-dialog-cancel-btn',
        create: 'proposals-create-product-dialog-create-btn',
        addNewVendor: 'proposals-create-product-dialog-add-new-vendor-btn',
      },
    },
  },
  equipment: {
    previewNewImagesDialog: {
      dialog: 'equipment-preview-new-images-dialog',
      actions: {
        cancel: 'equipment-preview-new-images-dialog-cancel-btn',
        confirm: 'equipment-preview-new-images-dialog-confirm-btn',
      },
    },
    previewExistingImagesDialog: {
      dialog: 'equipment-preview-existing-images-dialog',
      actions: {
        cancel: 'equipment-preview-existing-images-dialog-cancel-btn',
      },
    },
  },
} as const;
